export const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      const result = fileReader.result?.toString() ?? '';
      const [, formattedResult] = result.split(','); // remove file info from base64 string
      resolve(formattedResult);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};
